export const ruLng = {};
